import { useEffect, useRef, useCallback } from "react";
import { connect, useDispatch } from "react-redux";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { authAction } from "../data/redux/action/authAction";
import {
  clearIntervalId,
  removeJobAction,
  scheduleJobAction,
  setIntervalId,
} from "../data/redux/action/scheduleJobAction";
import BusinessIntelligence from "../presentation/pages/businessIntelligence/index";
import Transactions from "../presentation/pages/businessIntelligence/Transaction";
import CustomerIndex from "../presentation/pages/customerCenter";
import BeneficiaryIndex from "../presentation/pages/customerCenter/beneficiary/BeneficiaryIndex";
import BeneficiaryDetailsIndex from "../presentation/pages/customerCenter/beneficiary/beneficiary_details";
import DisplayCustomer from "../presentation/pages/customerCenter/display_customer";
import Dashboard from "../presentation/pages/dashboard";
import DeveloperCenter from "../presentation/pages/developerCenter";
import FinanceCenter from "../presentation/pages/financeCenter";
import ForgotPassword from "../presentation/pages/forgotPassword/index";
import Login from "../presentation/pages/login/index";
import Profile from "../presentation/pages/profile";
import ReportCenterIndex from "../presentation/pages/reportCenter";
import TransactionCenter from "../presentation/pages/transactionCenter";
import { INTERVAL_TIME } from "../presentation/resources/constantsManager";
import {
  SS_INTERVAL_ID,
  SS_INTERVAL_TIME,
  SS_REF_HASH_ID,
  SS_TOKEN,
} from "../presentation/resources/secureStorageManager";
import secureStorage from "../utility/secureStorage";
import { clearLocalStorageTimer } from "../utility/timerToClearStorage";
import moment from "moment";
import RegisterIndex from "../presentation/pages/register";

const Router = ({ isAuthenticated, seconds, intervalId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dataFetchedRef = useRef(false);

  const checkAuthenticatedOnReload = () => {
    try {
      const token = secureStorage.getItem(SS_TOKEN);
      const hashId = secureStorage.getItem(SS_REF_HASH_ID);
      if (token && hashId) {
        dispatch(authAction(true));
      }
    } catch (err) {
      console.log(err, "errro");
    }
  };

  const setIntervalForJob = async (time) => {
    var endDate = new Date();
    var startDate = new Date(time);

    var secondS = Math.round(
      Math.abs(endDate.getTime() - startDate.getTime()) / 1000
    );

    dispatch(scheduleJobAction(secondS - 10));

    let interval = setInterval(async () => {
      dispatch(scheduleJobAction(seconds + 1));
    }, 1000);

    secureStorage.setItem(SS_INTERVAL_TIME, startDate);
    dispatch(setIntervalId(interval));
    secureStorage.setItem(SS_INTERVAL_ID, interval);
  };

  const getTimeintervalAndId = async () => {
    const id = await secureStorage.getItem(SS_INTERVAL_ID);
    const time = await secureStorage.getItem(SS_INTERVAL_TIME);
    if (id && time && !seconds && !intervalId) {
      for (let i = 0; i < 100; i++) {
        window.clearInterval(i);
      }
      setIntervalForJob(time);
    }
  };

  const checkIdAndRemove = () => {
    if (seconds >= INTERVAL_TIME) {
      dispatch(removeJobAction());
      dispatch(clearIntervalId());
      const id = secureStorage.getItem(SS_INTERVAL_ID);
      clearInterval(id);
      for (let i = 0; i < 100; i++) {
        window.clearInterval(i);
      }
      secureStorage.removeItem(SS_INTERVAL_ID);
      secureStorage.removeItem(SS_INTERVAL_TIME);
    }
  };

  useEffect(() => {
    checkAuthenticatedOnReload();
    getTimeintervalAndId();
  }, []);

  useEffect(() => {
    dispatch(clearLocalStorageTimer(navigate));
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      checkIdAndRemove();
    }
  }, [seconds]);

  return (
    <>
      {isAuthenticated ? (
        <Routes>
          <Route path="*" element={<Navigate replace to="/dashboard" />} />
          <Route exact path="/dashboard" element={<Dashboard />} />
          <Route exact path="/transaction" element={<TransactionCenter />} />
          <Route exact path="/finance" element={<FinanceCenter />} />
          <Route exact path="/developers" element={<DeveloperCenter />} />
          <Route exact path="/profile" element={<Profile />} />
          <Route exact path="/business" element={<BusinessIntelligence />} />
          {/* <Route exact path="/report" element={<ReportCenterIndex />} /> */}
          <Route path="/customers" element={<CustomerIndex />}></Route>
          <Route path="/customers/:id" element={<DisplayCustomer />} />
          <Route path="/beneficary/:id" element={<BeneficiaryDetailsIndex />} />
          <Route
            exact
            path="/business/transaction"
            element={<Transactions />}
          />
        </Routes>
      ) : (
        <Routes>
          <Route path="*" element={<Navigate replace to="/login" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<RegisterIndex />} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />
        </Routes>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.AuthReducer.isAuthenticated,
    seconds: state.scheduleJobReducer.seconds,
    intervalId: state.scheduleJobReducer.intervalId,
  };
};
export default connect(mapStateToProps)(Router);
